// UI micro-copy only — navigation and content come from WordPress (Polylang + ACF)
// Covers: button labels, form messages, aria-labels, generic UI text

const t = {
  PT: {
    header: {
      book: "Reservar",
      bookNow: "Reservar agora",
      menu: "Menu",
      close: "Fechar",
      openMenu: "Abrir menu",
      closeMenu: "Fechar menu",
    },
    footer: {
      tagline: "Uma casa familiar em Paços de Ferreira, Portugal. Conforto, tranquilidade e hospitalidade genuína para toda a família.",
      ratingLabel: "no Booking.com",
      navigation: "Navegação",
      contact: "Contacto",
      bookOnBooking: "Reservar no Booking.com →",
      copyright: "Casa da Avó Miquinhas. Todos os direitos reservados.",
      privacy: "Política de Privacidade",
    },
    form: {
      submit: "Enviar mensagem",
      submitting: "A enviar...",
      successTitle: "Mensagem enviada!",
      successBody: "Obrigado pelo seu contacto. Entraremos em contacto consigo em breve.",
      sendAnother: "Enviar outra mensagem",
      error: "Ocorreu um erro. Por favor tente novamente.",
      required: "Este campo é obrigatório",
    },
    common: {
      readMore: "Ler mais",
      back: "Voltar",
      close: "Fechar",
      loading: "A carregar...",
      learnMore: "Saber mais",
    },
    nav: {
      soon: "Brevemente",
    },
  },

  EN: {
    header: {
      book: "Book",
      bookNow: "Book now",
      menu: "Menu",
      close: "Close",
      openMenu: "Open menu",
      closeMenu: "Close menu",
    },
    footer: {
      tagline: "A family home in Paços de Ferreira, Portugal. Comfort, tranquillity and genuine hospitality for the whole family.",
      ratingLabel: "on Booking.com",
      navigation: "Navigation",
      contact: "Contact",
      bookOnBooking: "Book on Booking.com →",
      copyright: "Casa da Avó Miquinhas. All rights reserved.",
      privacy: "Privacy Policy",
    },
    form: {
      submit: "Send message",
      submitting: "Sending...",
      successTitle: "Message sent!",
      successBody: "Thank you for getting in touch. We'll get back to you shortly.",
      sendAnother: "Send another message",
      error: "An error occurred. Please try again.",
      required: "This field is required",
    },
    common: {
      readMore: "Read more",
      back: "Back",
      close: "Close",
      loading: "Loading...",
      learnMore: "Learn more",
    },
    nav: {
      soon: "Coming soon",
    },
  },

  FR: {
    header: {
      book: "Réserver",
      bookNow: "Réserver maintenant",
      menu: "Menu",
      close: "Fermer",
      openMenu: "Ouvrir le menu",
      closeMenu: "Fermer le menu",
    },
    footer: {
      tagline: "Une maison de famille à Paços de Ferreira, Portugal. Confort, tranquillité et hospitalité authentique pour toute la famille.",
      ratingLabel: "sur Booking.com",
      navigation: "Navigation",
      contact: "Contact",
      bookOnBooking: "Réserver sur Booking.com →",
      copyright: "Casa da Avó Miquinhas. Tous droits réservés.",
      privacy: "Politique de confidentialité",
    },
    form: {
      submit: "Envoyer le message",
      submitting: "Envoi en cours...",
      successTitle: "Message envoyé !",
      successBody: "Merci de nous avoir contactés. Nous vous répondrons sous peu.",
      sendAnother: "Envoyer un autre message",
      error: "Une erreur s'est produite. Veuillez réessayer.",
      required: "Ce champ est obligatoire",
    },
    common: {
      readMore: "Lire la suite",
      back: "Retour",
      close: "Fermer",
      loading: "Chargement...",
      learnMore: "En savoir plus",
    },
    nav: {
      soon: "Bientôt",
    },
  },

  ES: {
    header: {
      book: "Reservar",
      bookNow: "Reservar ahora",
      menu: "Menú",
      close: "Cerrar",
      openMenu: "Abrir menú",
      closeMenu: "Cerrar menú",
    },
    footer: {
      tagline: "Una casa familiar en Paços de Ferreira, Portugal. Comodidad, tranquilidad y hospitalidad genuina para toda la familia.",
      ratingLabel: "en Booking.com",
      navigation: "Navegación",
      contact: "Contacto",
      bookOnBooking: "Reservar en Booking.com →",
      copyright: "Casa da Avó Miquinhas. Todos los derechos reservados.",
      privacy: "Política de privacidad",
    },
    form: {
      submit: "Enviar mensaje",
      submitting: "Enviando...",
      successTitle: "¡Mensaje enviado!",
      successBody: "Gracias por contactarnos. Nos pondremos en contacto pronto.",
      sendAnother: "Enviar otro mensaje",
      error: "Ocurrió un error. Por favor, inténtelo de nuevo.",
      required: "Este campo es obligatorio",
    },
    common: {
      readMore: "Leer más",
      back: "Volver",
      close: "Cerrar",
      loading: "Cargando...",
      learnMore: "Saber más",
    },
    nav: {
      soon: "Próximamente",
    },
  },

  DE: {
    header: {
      book: "Buchen",
      bookNow: "Jetzt buchen",
      menu: "Menü",
      close: "Schließen",
      openMenu: "Menü öffnen",
      closeMenu: "Menü schließen",
    },
    footer: {
      tagline: "Ein Familienhaus in Paços de Ferreira, Portugal. Komfort, Ruhe und echte Gastfreundschaft für die ganze Familie.",
      ratingLabel: "auf Booking.com",
      navigation: "Navigation",
      contact: "Kontakt",
      bookOnBooking: "Auf Booking.com buchen →",
      copyright: "Casa da Avó Miquinhas. Alle Rechte vorbehalten.",
      privacy: "Datenschutzrichtlinie",
    },
    form: {
      submit: "Nachricht senden",
      submitting: "Wird gesendet...",
      successTitle: "Nachricht gesendet!",
      successBody: "Vielen Dank für Ihre Nachricht. Wir melden uns in Kürze.",
      sendAnother: "Weitere Nachricht senden",
      error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
      required: "Dieses Feld ist erforderlich",
    },
    common: {
      readMore: "Mehr lesen",
      back: "Zurück",
      close: "Schließen",
      loading: "Lädt...",
      learnMore: "Mehr erfahren",
    },
    nav: {
      soon: "Demnächst",
    },
  },
}

// Helper: get translations for given lang code, falls back EN → PT
export const useT = (lang) => {
  const code = lang?.toUpperCase() || "PT"
  return t[code] || t["EN"] || t["PT"]
}

export default t
